import { render, staticRenderFns } from "./sharingScreen.vue?vue&type=template&id=763ab268"
import script from "./sharingScreen.vue?vue&type=script&lang=js"
export * from "./sharingScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports